document.addEventListener('DOMContentLoaded', function () {

    let __eb_prev = null;

  const root = document.querySelector('[data-exchange-board-v2]');
  if (!root) return;

  const endpoint = (root.dataset.endpoint || '').trim();
  if (!endpoint || endpoint === 'https://example.com') {
    console.log('Exchange Board V2: endpoint not configured');
    return;
  }

  function safeArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function timeAgo(iso) {
    if (!iso) return 'Awaiting live board data';

    const now = new Date();
    const date = new Date(iso);
    const diff = Math.floor((now - date) / 1000);

    if (diff < 10) return 'Updated just now';
    if (diff < 60) return `Updated ${diff}s ago`;

    const mins = Math.floor(diff / 60);
    if (mins < 60) return `Updated ${mins} min ago`;

    const hrs = Math.floor(mins / 60);
    return `Updated ${hrs} hr ago`;
  }

  function setMetric(key, value) {
    const el = root.querySelector(`[data-eb-metric="${key}"]`);
    if (!el) return;

    el.classList.add('is-updating');
    setTimeout(() => {
      el.textContent = String(value ?? 0);
      el.classList.remove('is-updating');
    }, 150);
  }

  function renderPanel(panelName, lines) {
    const panel = root.querySelector(`[data-eb-panel="${panelName}"]`);
    if (!panel) return;

    const finalLines = safeArray(lines).filter(Boolean);

    panel.innerHTML = finalLines.map((line, index) => {

      const isPrimary = panelName === 'state' && index === 0;

      return `
        <article class="exchange-board__stack-item ${isPrimary ? 'is-primary' : ''}">
          <p class="exchange-board__stack-text">${line}</p>
        </article>
      `;
    }).join('');
  }

  // 🔴 STATE INTELLIGENCE



  function getSignalScore(count, thresholds) {
  const { low, mid, high } = thresholds;

  if (count >= high) return { score: 10, trend: '↑' };
  if (count >= mid) return { score: 7, trend: '↑' };
  if (count >= low) return { score: 4, trend: '→' };
  return { score: 2, trend: '↓' };
}



function getConfidence(count, maxExpected) {
  if (!maxExpected) return 0.5;
  return Math.min(1, (count / maxExpected)).toFixed(2);
}


function getVelocity(current, previous) {
  if (!previous) return 0;

  const delta = current - previous;

  if (delta > 0) return `+${delta}`;
  if (delta < 0) return `${delta}`;
  return '0';
}


function getWeightedSystemScore(d, s, t, l) {

  const demand = getSignalScore(d, { low: 3, mid: 6, high: 10 }).score;
  const supply = getSignalScore(s, { low: 3, mid: 6, high: 10 }).score;
  const transactions = getSignalScore(t, { low: 10, mid: 20, high: 50 }).score;
  const logistics = getSignalScore(l, { low: 2, mid: 4, high: 8 }).score;

  // 🔴 WEIGHTS (execution dominant)
  const score =
    (transactions * 0.4) +
    (demand * 0.25) +
    (supply * 0.2) +
    (logistics * 0.15);

  let trend = '→';

  if (score >= 8) trend = '↑';
  else if (score <= 4) trend = '↓';

  return {
    score: score.toFixed(1),
    trend
  };
}




function getStateSignals(data) {

  const d = data.demand.length;
  const s = data.supply.length;
  const t = data.transactions.length;
  const l = data.logistics.length + data.distance.length;

  const prev = __eb_prev || {};

  const demandScore = getSignalScore(d, { low: 3, mid: 6, high: 10 });
  const supplyScore = getSignalScore(s, { low: 3, mid: 6, high: 10 });
  const txScore = getSignalScore(t, { low: 10, mid: 20, high: 50 });
  const logScore = getSignalScore(l, { low: 2, mid: 4, high: 8 });

  function confidenceLabel(val) {
    if (val >= 0.8) return 'High';
    if (val >= 0.5) return 'Moderate';
    return 'Low';
  }

  
function velocityLabel(v) {
  if (v > 0) return '<span class="eb-velocity-up">Rising</span>';
  if (v < 0) return '<span class="eb-velocity-down">Declining</span>';
  return '<span class="eb-velocity-stable">Stable</span>';
}



function formatLine(text, score, trend, confidence, velocity) {
  return `
    <span class="eb-text">${text}</span>

   <span class="exchange-board__metrics-row">
      <span class="eb-left">
        ${score}/10 ${trend} · Confidence: ${confidenceLabel(confidence)} · Velocity:
      </span>
      <span class="eb-right">
        ${velocityLabel(velocity)}
      </span>
    </span>
  `.trim();
}



  const lines = [];

  const vT = getVelocity(t, prev.t);
  const vD = getVelocity(d, prev.d);
  const vS = getVelocity(s, prev.s);
  const vL = getVelocity(l, prev.l);

  if (t >= 20) {
    lines.push(
      formatLine(
        'Execution layer is operating at high throughput across coordinated transactions.',
        txScore.score,
        txScore.trend,
        getConfidence(t, 50),
        vT
      )
    );
  }

  if (d >= 6) {
    lines.push(
      formatLine(
        'Repeated demand signals are consolidating into execution-ready clusters.',
        demandScore.score,
        demandScore.trend,
        getConfidence(d, 10),
        vD
      )
    );
  }

  if (s >= 6) {
    lines.push(
      formatLine(
        'New supplier activity is expanding coverage across the network.',
        supplyScore.score,
        supplyScore.trend,
        getConfidence(s, 10),
        vS
      )
    );
  }

  if (l >= 4) {
    lines.push(
      formatLine(
        'Logistics movement signals are active across emerging routes.',
        logScore.score,
        logScore.trend,
        getConfidence(l, 8),
        vL
      )
    );
  }

  const convergence = (d >= 6 && s >= 6 && l >= 4);

  if (convergence && t >= 20) {
    lines.push('System convergence achieved — demand, supply, and execution layers are fully aligned.');
  } else if (convergence) {
    lines.push('System convergence strengthening — demand, supply, and logistics aligning toward execution.');
  } else {
    lines.push('System layers are active but not yet fully aligned.');
  }

  __eb_prev = { d, s, t, l };

  return lines;
}


  function getDemandSignals(demand) {
    if (demand.length >= 10) {
      return [
        pick([
          'Repeated demand signals are consolidating into execution-ready clusters.',
          'Demand pressure is concentrating into coordinated procurement patterns.'
        ]),
        'Multiple procurement entries are aligning.'
      ];
    }
    return ['Early demand signals are forming.'];
  }

  function getSupplySignals(supply) {
    if (supply.length >= 8) {
      return [
        'New supplier activity is expanding coverage across the network.',
        'Supply capacity is scaling across regions.'
      ];
    }
    return ['Early supply activation is forming.'];
  }

  function getTransactionSignals(transactions) {
    if (transactions.length >= 50) {
      return [
        'High-volume transaction activity is stabilizing into continuous execution.',
        'Cooperative payment rails are active in recent transaction activity.'
      ];
    }
    return ['Early transaction signals are appearing.'];
  }

  function getLogisticsSignals(logistics, distance) {
    const lines = [];

    if (logistics.length) {
      lines.push('Logistics movement signals are active across emerging routes.');
    }

    if (distance.length >= 2) {
      lines.push('Route evaluation signals are increasing across regions.');
    }

    return lines;
  }

  function renderBoard(data) {

    root.classList.add('is-active');

    setMetric('demand', data.metrics?.demand_signals ?? 0);
    setMetric('supply', data.metrics?.suppliers ?? 0);
    setMetric('transactions', data.metrics?.transactions ?? 0);
    setMetric('logistics', data.metrics?.logistics_requests ?? 0);

    const d = data.demand.length;
const s = data.supply.length;
const t = data.transactions.length;
const l = data.logistics.length + data.distance.length;

const system = getWeightedSystemScore(d, s, t, l);

const systemEl = root.querySelector('[data-eb-system-score]');
if (systemEl) {
  systemEl.textContent = `${system.score} / 10 ${system.trend}`;
}

    const updatedEl = root.querySelector('[data-eb-updated]');
    if (updatedEl) {
      updatedEl.textContent = timeAgo(data.generated_at);
    }

    renderPanel('state', getStateSignals(data));
    renderPanel('demand', getDemandSignals(safeArray(data.demand)));
    renderPanel('supply', getSupplySignals(safeArray(data.supply)));
    renderPanel('transactions', getTransactionSignals(safeArray(data.transactions)));
    renderPanel('logistics', getLogisticsSignals(safeArray(data.logistics), safeArray(data.distance)));
  }

  init();

  function init() {

    root.classList.add('is-loading');

    const cached = sessionStorage.getItem('eb_v2_payload');

    if (cached) {
      try {
        const data = JSON.parse(cached);
        if (data && data.ok) {
          renderBoard(data);
        }
      } catch (e) {}
    }

    fetchBoard();

    // 🔥 KEEP LIVE FEEL (SAFE)
    setInterval(fetchBoard, 20000);
  }

  async function fetchBoard() {
    try {
      const response = await fetch(endpoint, { method: 'GET', cache: 'no-store' });
      const data = await response.json();

      if (!data || !data.ok) return;

      sessionStorage.setItem('eb_v2_payload', JSON.stringify(data));

      root.classList.remove('is-loading');
      renderBoard(data);

    } catch (error) {
      console.log('Exchange Board fetch error:', error);
    }
  }

});